module.exports = __webpack_public_path__ + "static/media/mp4.f28da52a.svg";